module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-filter-or-block"
  }, [_c('div', {
    staticClass: "block"
  }, _vm._l((_vm.expression.args), function(arg, argId) {
    return _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('div', {
      staticClass: "orLine"
    }, [_vm._v("OR")]) : _vm._e(), _vm._v(" "), _c('FilterExpression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    }), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addArg
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("add")]), _vm._v(" OR\n      ")]) : _vm._e(), _vm._v(" "), (_vm.definition.isList && argId + 1 == _vm.expression.args.length) ? _c('button', {
      staticClass: "mdl-button add-button",
      on: {
        "click": _vm.addOuterAnd
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("add")]), _vm._v(" AND\n      ")]) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a69611"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/query/SimpleFilterOrBlock.vue
// module id = 458
// module chunks = 0